module.exports = __webpack_public_path__ + "static/media/05.865b28c1.mp3";